import React from 'react';
import Layout from '../../components/Layout';
import Contact from './Contact';
import messages from '../../locale/messages';
import { getBatch2PageSeo } from '../../helpers/routeSeo';

export default async function action({ store }) {
  const { title, description } = getBatch2PageSeo(
    store,
    messages.batch2ContactMetaTitle,
    messages.batch2ContactMetaDescription,
  );
  return {
    title,
    description,
    component: <Layout><Contact /></Layout>,
  };
};
